// @ts-nocheck
import React from 'react';

const NumberFormatter = ({ amount = 0 }) => {
  // Check if the value is a valid number, otherwise return "-"
  if (amount === 0 ) {
    return "0";
  } else if(amount === "-") {
    return "-";
  }
  
  // Format the number if it's valid
  return new Intl.NumberFormat('en-US').format(amount);
};

export default NumberFormatter;
